import {
  Chip
} from '@material-ui/core';
import { makeStyles,Theme, createStyles } from '@material-ui/core/styles';
import { BORROWER_ENTITY_AUTOMATION_SUCCESS_STATUS,BORROWER_ENTITY_AUTOMATION_IN_PROGRESS_STATUS } from '../../../constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chipManual: {
      backgroundColor: theme.palette.success.main,
      color: 'white',
      marginLeft: theme.spacing(2),
    },
    chipAutomated: {
      backgroundColor: theme.palette.warning.main,
      color: 'white',
      marginLeft: theme.spacing(2),
    },
    chipInProgress: {
      backgroundColor: theme.palette.warning.main,
      color: 'white',
      marginLeft: theme.spacing(2),
    },
  })
);

export const BorrowerEntityAutomationStatusChip = ({ properties }) => {
  const classes = useStyles();
  return (
    <Chip
      size="small"
      className={properties.status === BORROWER_ENTITY_AUTOMATION_SUCCESS_STATUS ? classes.chipAutomated :
        properties.status === BORROWER_ENTITY_AUTOMATION_IN_PROGRESS_STATUS ? classes.chipInProgress : classes.chipManual}
      label={properties.label}
    />
  );
};